import {Component, OnDestroy, OnInit} from '@angular/core'
import {AuthService} from '../../shared/services/auth.service'
import {AdminV1, UserData} from '../../shared/interfaces/userLogin'
import {environment} from '../../../environments/environment'
import {VendorsEtc} from '../../shared/services/cache.etc/vendors'
import {AccountKV, DashboardService} from './dashboard.service'
import {Dashboard} from './iface'
import {Subscription} from 'rxjs'
import {BreadcrumbsService} from '../../shared/components/main-layout/breadcrumbs.service'
import {IdbCache} from '../../shared/services/cache.etc/idb.cache'
import {Vendors} from '../vendor.items/list/list.service'
import {NotificatorService} from '../../shared/services/notificator.service'

interface OwnerItem {
  category: string // Attractions / Shows / Dining / Hotels
  amount: number
  markers: {
    draft: boolean
    rejected: boolean
    pending: boolean
  }
  flags: {
    noAllotments: boolean
    noRateLevels: boolean
    noSchedules: boolean
  }
  items: Vendors[]
}

export interface Owner {
  name: string // Owner Name
  active: boolean
  status: 'OK' | 'U' | 'E' | 'P' // all OK | DRAFT or PENDING | EMPTY ITEMS
  counters: {
    draft: number
    rejected: number
    pending: number
    items: number
    approved: number
    unlinkedFlags: number
    flags: {
      allotments: number
      schedules: number
      rateLevels: number
    }
  }
  items: {
    shows: OwnerItem
    attractions: OwnerItem
    hotels: OwnerItem
    dining: OwnerItem
  }
  names: string[] // vi names
  // helpers
  spoilerExpand?: boolean
}


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  currentAuth: UserData = null
  data: Dashboard
  accounts: AccountKV = {} as AccountKV
  // Filters [begin]
  fAAWs = true  // All As Well - status
  fAAWi = 0     // All As Well - counter
  fUs = true    // Unfinished - status
  fUi = 0       // Unfinished - counter
  fEs = true    // Empty - status
  fEi = 0       // Empty - counter
  fPs = true    // Pending - status
  fPi = 0       // Pending - counter
  fAcp = true
  fAci = 0       // Count Active companies
  fInp = true
  fIni = 0       // Count Inactive companies
  adminData: { [key: string]: Owner } = {}
  adminDataSize = 0
  clientHeight = 0
  loginAsCompanySub: Subscription
  loggedAsCompany: boolean
  adminLoggedAsCompany: AdminV1 | null = null
  isAdmin: boolean
  inited: boolean
  loading = true
  modal = {
    visible: false,
    initDone: false,
    title: null as string | null,
    data: null as Owner | null,
    close: () => {
      this.modal.visible = false
      this.modal.initDone = false
    },
    open: (owner: Owner) => {
      // console.log('open modal details for ', owner)
      this.modal.data = owner
      this.modal.title = owner.name
      this.modal.initDone = true
      this.modal.visible = true
    }
  }
  bar = {
    search: null as string | null,
    searchBy: 'C',
    searchPlaceholder: 'Search by ',
    searchHandler: () => {
    },
    searchByHandler: () => {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        // console.log('LDR-06')
      }, 100)
    }
  }

  resetAdminDb() {
    this.fAAWs = true
    this.fAAWi = 0
    this.fUs = true
    this.fUi = 0
    this.fEs = true
    this.fEi = 0
    this.fPs = true
    this.fPi = 0
    this.adminData = {}
  }

  /**
   * Toggle spoiler to show Company Vendor Items
   * Using for Admin
   * @param item -
   */
  toggleSpoiler(item: Owner) {
    item.spoilerExpand = !item.spoilerExpand
  }

  /**
   * Login As Compeny
   * Using for Admin
   * @param owner -
   */
  loginAsCompany(owner: string) {
    const LS = localStorage.getItem('listCompanies')
    if (LS) {
      const companies: AdminV1[] = JSON.parse(LS)
      const C = companies.find(c => c.adminId === owner)
      if (!C) {
        this.notify.createNotification('error', 'Internal Error', 'Unable to Login As Company. Re-login and try again')
        return
      }
      this.auth.activateCompanyView(C)
    } else {
      this.notify.createNotification('error', 'Internal Error', 'Unable to Login As Company. Re-login and try again')
    }
  }

  logout() {
    this.auth.deactivateCompanyView()
  }

  /**
   * Subscription on change <login company>
   * Using for Admin
   */
  subOnChangeCompanyLogin() {
    this.loginAsCompanySub = this.auth.asCompanyChanges().subscribe(cd => {
      // console.log('sub on change AAC', cd)
      if (cd) {
        this.loggedAsCompany = (cd.adminId) ? true : false
        this.adminLoggedAsCompany = cd
      } else {
        this.loggedAsCompany = false
        this.adminLoggedAsCompany = null
      }
      this.inited = false
      this.loading = true
      this.initData()
    })
  }

  /**
   * INIT DATA FOR ADMIN OR COMPANY
   */
  initData(forceReload?: boolean) {
    if (forceReload) {
      this.inited = false
      this.loading = true
    }
    if (!this.isAdmin && !this.loggedAsCompany) {
      // console.log('1-NATIVE-CMP')
      this.DS.getAnalyticDataForCompany(this.currentAuth.companyId)
        .then(res => {
          this.data = res
          // console.log('got data: ', res)
          this.inited = true
          this.loading = false
          // console.log('LDR-01')
        }, error => {
          console.log('error: ', error)
          this.loading = false
          // console.log('LDR-02')
        })
    } else if (this.loggedAsCompany) {
      // console.log('2-AAC')
      this.DS.getAnalyticDataForCompany(this.adminLoggedAsCompany.adminId)
        .then(res => {
          this.data = res
          // console.log('got data: ', res)
          this.inited = true
          this.loading = false
          // console.log('LDR-03')
        }, error => {
          console.log('error: ', error)
          this.loading = false
          // console.log('LDR-04')
        })
    } else {
      // console.log('3-A')
      // const res = allVi
      // res.forEach(i => {
      //   if (this.adminData[i.owner]) {
      //     this.adminData[i.owner].push(i)
      //   } else {
      //     this.adminData[i.owner] = [i]
      //   }
      // })
      // this.loading = false
      // console.log('ALL-VI:', res)
      // TODO - надто довго завантажується
      // this.VS.syncAllVendors(true)
      // this.DS.getAllVendors()
      // this.IDBC.bootstrap()
      // TODO UNCOMENT IT
      const makeOwner = ((item: Vendors): Owner => {
        const getStatus = ((s: string) => {
          return item.applied.status === s
        })
        const getItem = (fc: string) => {
          const cc = environment.categoryDec2Str(item.vendor.category, 'ids')
          return {
            category: fc,
            amount: (fc === cc.plural) ? 1 : 0,
            markers: {
              draft: (fc === cc.plural) ? getStatus('DRAFT') : false,
              rejected: (fc === cc.plural) ? getStatus('REJECTED') : false,
              pending: (fc === cc.plural) ? getStatus('PENDING') : false
            },
            flags: {
              noAllotments: (fc === cc.plural) ? item.vendorFlags.noAllotments : false,
              noRateLevels: (fc === cc.plural) ? item.vendorFlags.noRateLevels : false,
              noSchedules: (fc === cc.plural) ? item.vendorFlags.noSchedules : false
            },
            items: (fc === cc.plural) ? [item] : []
          }
        }
        return {
          name: this.accounts[item.owner].administrator,
          status: null,
          active: this.accounts[item.owner].adminStatus,
          counters: {
            draft: getStatus('DRAFT') ? 1 : 0,
            rejected: getStatus('REJECTED') ? 1 : 0,
            pending: getStatus('PENDING') ? 1 : 0,
            items: 1,
            approved: getStatus('APPROVED') ? 1 : 0,
            // unlinkedFlags: (item.vendorFlags.noAllotments || item.vendorFlags.noRateLevels || item.vendorFlags.noSchedules) ? 1 : 0,
            unlinkedFlags: (item.vendorFlags.noAllotments && item.vendorFlags.noSchedules) ? 1 : 0,
            flags: {
              allotments: item.vendorFlags.noAllotments ? 0 : 1,
              schedules: item.vendorFlags.noSchedules ? 0 : 1,
              rateLevels: item.vendorFlags.noRateLevels ? 0 : 1
            }
          },
          items: {
            attractions: getItem('attractions'),
            shows: getItem('shows'),
            dining: getItem('dining'),
            hotels: getItem('hotels'),
          },
          names: [item.applied.name]
        }
      })
      const makeOwnerData = ((item: Vendors) => {
        if ([1, '1', 'hotels'].includes(item.vendor.category)) {
          return // Ignore priceline-hotels
        }
        const cc = environment.categoryDec2Str(item.vendor.category)
        const getStatus = ((s: string) => item.applied.status === s)
        const statuses = ['APPROVED', 'DRAFT', 'REJECTED', 'PENDING']
        const flags = ['noAllotments', 'noRateLevels', 'noSchedules']
        const ownerItems = this.adminData[item.owner].items as Record<string, OwnerItem>
        // Add VI-data to Owner.items[category].items
        // console.log('handle category ', cc.plural)
        ownerItems[cc.plural].items.push(item)
        this.adminData[item.owner].names.push(item.applied.name)
        // COUNTERS [>]
        ownerItems[cc.plural].amount++
        // Flags Count
        if (!item.vendorFlags.noAllotments) {
          this.adminData[item.owner].counters.flags.allotments++
        }
        if (!item.vendorFlags.noSchedules) {
          this.adminData[item.owner].counters.flags.schedules++
        }
        if (!item.vendorFlags.noRateLevels) {
          this.adminData[item.owner].counters.flags.rateLevels++
        }
        // COUNTERS [/]
        // Tick counter owner-items
        this.adminData[item.owner].counters.items++
        // Handle counters and flags
        statuses.forEach(s => {
          if (getStatus(s)) {
            // Owner-counters
            const counterKey = s.toLowerCase() as 'draft' | 'rejected' | 'pending' | 'approved'
            this.adminData[item.owner].counters[counterKey]++
            // Owner-items[category]-markers
            const markerKey = s.toLowerCase() as keyof OwnerItem['markers']
            ownerItems[cc.plural].markers[markerKey] = true
          }
        })
        // Owner-items[category]-flags
        flags.forEach(f => {
          if (item.vendorFlags[f as keyof typeof item.vendorFlags]) {
            const flagKey = f as keyof OwnerItem['flags']
            ownerItems[cc.plural].flags[flagKey] = true
          }
        })
      })
      // this.IDBC.vendorFormsCc(true) --- DEPRECATED from 2024-04-24
      this.IDBC.getVendorForms().then(res => {
        // console.log('GOT_VENDOR_FORMS:', res)
        this.resetAdminDb()
        // console.log('got vendors data: ', res)
        res.forEach(item => {
          if (this.adminData[item.owner]) {
            // Add VI-data to Owner
            makeOwnerData(item)
          } else {
            // Create new Owner
            this.adminData[item.owner] = makeOwner(item)
          }
        })
        for (const o of Object.keys(this.adminData)) {
          const i = this.adminData[o]
          // Sum Active/Inactive
          if (this.adminData[o].active) {
            this.fAci++
          } else {
            this.fIni++
          }
          if (
            (i.counters.draft + i.counters.pending + i.counters.rejected) === 0 &&
            i.counters.approved > 0 &&
            i.counters.approved === i.counters.flags.allotments &&
            i.counters.approved === i.counters.flags.schedules
          ) {
            this.adminData[o].status = 'OK'
            if (i.active) {
              this.fAAWi++
            }
          }
          // Pending
          else if (
            i.counters.pending > 0 || i.counters.rejected > 0
          ) {
            this.adminData[o].status = 'P'
            if (i.active) {
              this.fPi++
            }
          }
          // Empty
          else if (i.counters.items === 0) {
            this.adminData[o].status = 'E'
            if (i.active) {
              this.fEi++
            }
          }
          // Unfinished
          else {
            this.adminData[o].status = 'U'
            if (i.active) {
              this.fUi++
            }
          }
        }
        this.loading = false
        // console.log('LDR-05')
      }, error => {
        console.log('Error gor vendors data...', error)
      })
    }
  }

  reGet() {
    // this.IDBC.vendorFormsCc(true) --- DEPRECATED
    this.IDBC.getVendorForms()
      .then(res => {
        // console.log('got vendors data: ', res)
      }, error => {
        console.log('error: ', error)
      })
  }

  constructor(
    private auth: AuthService,
    private VS: VendorsEtc,
    private DS: DashboardService,
    private Breadcrumbs: BreadcrumbsService,
    private IDBC: IdbCache,
    private notify: NotificatorService
  ) {
    this.Breadcrumbs.updateState([{
      title: 'Dashboard',
      icon: null,
    }])
  }

  ngOnInit(): void {
    console.log('DASHBOARD: ', this)
    this.clientHeight = document.body.clientHeight - 220
    if (!this.auth.isAuthenticated()) {
      this.auth.logout()
      return
    }

    this.DS.getAllAdmins().then(res => {
      // console.log('got all admins: ', res)
      this.accounts = res
      // Next init
      this.auth.getCurrentUserData().subscribe((user: UserData) => {
        this.currentAuth = user
        this.isAdmin = (user.type === 'admin')
        if (this.isAdmin) {
          this.subOnChangeCompanyLogin()
          return
        } else {
          this.initData()
        }
      })
    }, error => {
      console.log('error got accounts data: ', error)
    })


    const viCats = []
    for (const i of environment.categoriesList) {
      viCats.push(
        this.VS.getVendorByCategory(i.api)
      )
    }
  }

  ngOnDestroy() {
    if (this.loginAsCompanySub) {
      this.loginAsCompanySub.unsubscribe()
    }
  }

  // protected readonly Object = Object
}
